import { NgxScrollPositionRestorationConfig } from './ngx-scroll-position-restoration-config';

export const defaultNgxScrollPositionRestorationConfig: NgxScrollPositionRestorationConfig = {
  pollDuration: 3000,
  pollCadence: 50,
  debug: false
};
